import styled from "styled-components";
import colours from "styles/colours";
import shadows from "styles/shadows";

export const OldPanelContainer = styled.div<{ $colour?: string }>`
  background-color: ${colours.white};
  box-shadow: 3px 3px 10px 5px rgba(0, 0, 0, 0.1);
  border-radius: 3px;

  border-top: 8px solid
    ${({ $colour }): string => $colour ?? colours.elexonBlue};
`;

export const PanelContainer = styled.div<{
  $colour?: string;
}>`
  background-color: ${colours.white};

  border-top: 1px solid
    ${({ $colour }): string => $colour ?? colours.elexonBlue};

  &.mini-tile {
    border-top: none;
    border-left: 1px solid ${colours.elexonBlue};
    box-shadow: ${shadows.shadowMd};
  }
`;
